import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "header-main-icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Se déconnecter")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Factures")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Se deconnecter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_JbHeader = _resolveComponent("JbHeader")!
  const _component_JbButton = _resolveComponent("JbButton")!
  const _component_JbProfile = _resolveComponent("JbProfile")!
  const _component_JbMenu = _resolveComponent("JbMenu")!
  const _component_JbSidebar = _resolveComponent("JbSidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_JbMainContainer = _resolveComponent("JbMainContainer")!
  const _component_JbToastsDisplay = _resolveComponent("JbToastsDisplay")!
  const _component_JbWebpage = _resolveComponent("JbWebpage")!
  const _component_InvoiceCreateModal = _resolveComponent("InvoiceCreateModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_JbWebpage, null, {
      default: _withCtx(() => [
        _createVNode(_component_JbHeader, { class: "bg-neutral-100 drop-shadow" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_router_link, { to: "/iori" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "h-12",
                    src: _ctx.$ContentManagerUrl+'/uploads/thumbnail_logo_6b686a108c.png'
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              })
            ]),
            _hoisted_3,
            _createElementVNode("div", {
              class: "sidebar-toggle-btn",
              id: "left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$JbStore.leftSidebar.toggle()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "bars" })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_JbSidebar, {
          side: "left",
          toggle: _ctx.$JbStore.leftSidebar.get()
        }, {
          default: _withCtx(() => [
            _createVNode(_component_JbProfile, {
              name: _ctx.username,
              role: _ctx.role
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/logout" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_JbButton, {
                      size: "l",
                      "icon-left": "sign-out-alt",
                      fullwidth: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["name", "role"]),
            _createVNode(_component_JbMenu, null, {
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/iori/factures" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "file-invoice-dollar" }),
                        _hoisted_5,
                        _createVNode(_component_JbButton, {
                          "icon-left": "plus",
                          class: "ml-auto",
                          bg: "bg-sky-500 hover:bg-sky-400",
                          text: "text-white",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.emitter.emit('open-modal-invoice-create')), ["prevent"]))
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["toggle"]),
        _createVNode(_component_JbMainContainer, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_JbSidebar, {
          side: "right",
          toggle: _ctx.$JbStore.rightSidebar.get()
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$i18n.locale = 'en'))
            }, "English"),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$i18n.locale = 'fr'))
            }, "Français"),
            _createElementVNode("button", null, [
              _createVNode(_component_router_link, { to: "/logout" }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "file-invoice-dollar" }),
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["toggle"]),
        _createVNode(_component_JbToastsDisplay)
      ]),
      _: 1
    }),
    _createVNode(_component_InvoiceCreateModal)
  ]))
}